import React from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import Translate from '../../i18n/Translate/Translate';
import './InformativeCard.scss';
import WarningMsg from '../ColorMsg/ColorMsg';
import alertIcon from '../../assets/img/other/alert-Icon.svg';

const InformativeCard = ({
  title,
  description,
  img,
  primaryBtn,
  secondaryBtn,
  primaryOnClick,
  secondaryOnClick,
  warningMsg,
}) => (
  <div className="d-flex justify-content-center">
    <Card className="informative-card">
      <CardBody>
        <div className="d-flex flex-column align-items-center">
          <img src={img} alt="logo" className="wmb-2" />
          <h3 className="text-center font-20 font-weight-bolder mt-4">
            <Translate translationKey={title} />
          </h3>
          <h4 className="font-16 mt-3 font-weight-light text-center">
            <Translate translationKey={description} />
          </h4>
          {warningMsg && (
          <WarningMsg type="warning" msg={warningMsg} icon={alertIcon} />
          )}
          <Button
            className="issuer-button-primary informative-card__primary-btn mt-4"
            size="lg"
            onClick={() => primaryOnClick()}
          >
            <Translate translationKey={primaryBtn} />
          </Button>
          {secondaryBtn && (
          <Button
            className="mt-3"
            color="link"
            size="lg"
            block
            type="button"
            onClick={() => secondaryOnClick()}
          >
            <Translate translationKey={secondaryBtn} />
          </Button>
          )}
        </div>
      </CardBody>
    </Card>
  </div>
);

InformativeCard.defaultProps = {
  secondaryBtn: '',
  secondaryOnClick: () => undefined,
  warningMsg: '',
};

InformativeCard.propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  primaryBtn: PropTypes.string.isRequired,
  primaryOnClick: PropTypes.func.isRequired,
  secondaryBtn: PropTypes.string,
  secondaryOnClick: PropTypes.func,
  warningMsg: PropTypes.string,
};

export default InformativeCard;
